import "./Artistry.module.css";
import Header from "@/reusable_sections/Header";
import OurCraft from "./sections/OurCraft";
import TheExtensionSuite from "./sections/TheExtensionSuite";
import DownloadFullMenu from "./sections/DownloadFullMenu";
import Footer from "@/reusable_sections/Footer";
export default function ArtistryPage() {
  return <div>
      <Header />
      <OurCraft />
      <TheExtensionSuite />
      <DownloadFullMenu />
      <Footer />
    </div>;
}